import React from 'react';

/* The "+ Add" chooser.

   Ordered follow → visit → offer — the sequence an athlete actually moves
   through, so the list reads as a progression rather than an arbitrary menu.
   Same ordering and reasoning as AddRecruitingEventSheet.swift. */

const StarGlyph = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 3l2.7 5.5 6.1.9-4.4 4.3 1 6-5.4-2.8-5.4 2.8 1-6L3.2 9.4l6.1-.9z" />
  </svg>
);

const PinGlyph = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 21s7-6.3 7-11a7 7 0 10-14 0c0 4.7 7 11 7 11z" />
    <circle cx="12" cy="10" r="2.5" />
  </svg>
);

const MailGlyph = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="M22 6l-10 7L2 6" />
  </svg>
);

const OPTIONS = [
  { key: 'following', title: 'Follow a school', sub: 'Put it on your radar and pick your updates', Icon: StarGlyph },
  { key: 'visits', title: 'Log a visit', sub: 'A campus tour, game day or camp', Icon: PinGlyph },
  { key: 'offers', title: 'Log an offer', sub: 'Something a program has put in writing', Icon: MailGlyph },
];

export default function AddEventMenu({ onPick }) {
  return (
    <div>
      {OPTIONS.map(({ key, title, sub, Icon }) => (
        <button
          key={key}
          type="button"
          className="rail-addmenu__row"
          onClick={() => onPick(key)}
          data-testid={`rail_add_${key}`}
        >
          <span className={`rail-addmenu__tile rail-addmenu__tile--${key}`} aria-hidden="true">
            <Icon />
          </span>
          <span>
            <span className="rail-addmenu__title">{title}</span>
            <span className="rail-addmenu__sub">{sub}</span>
          </span>
        </button>
      ))}
    </div>
  );
}
